import * as React from "react";
import Axios from "axios";
import { useNavigate, useParams } from "react-router-dom";

import {
  Box,
  //Container,
  //Paper,
  Grid,
  Card,
  CardContent,
  Button,
  Typography,
  Dialog,
  DialogContent,
  CardMedia,
} from "@mui/material";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import { useTranslation } from "react-i18next";

import Layout from "./Layout/Layout";

import "./Lobby.css";

async function getGameList(userId) {
  try {
    let result = await Axios.get(
      `${process.env.REACT_APP_BACKEND_DOMAIN_API}/game_web/gamification/all_list`,
      {
        headers: {
          "Content-Type": "application/json",
          "x-api-key": process.env.REACT_APP_X_API_KEY,
          "x-access-token": sessionStorage.getItem("accessToken"),
          //"x-access-token": process.env.REACT_APP_TOKEN,
        },
      }
    );
    //console.log(result.data.data[0]);
    return result.data;
  } catch (error) {
    console.log(`bigc-line-coupon-web: ${error}`);
    return {
      status: "failed",
      message: error.message,
    };
  }
}

async function gameCalculatorPlayPerGame(credentials) {
  try {
    let payload = JSON.stringify(credentials);
    let result = await Axios.post(
      `${process.env.REACT_APP_BACKEND_DOMAIN_API}/game_web/gamification/game_calculator_play_per_game`,
      payload,
      {
        headers: {
          "Content-Type": "application/json",
          "x-api-key": process.env.REACT_APP_X_API_KEY,
          "x-access-token": sessionStorage.getItem("accessToken"),
          //"x-access-token": process.env.REACT_APP_TOKEN,
        },
      }
    );
    //console.log(result);
    return result.data;
  } catch (error) {
    console.log(`bigc-line-coupon-web: ${error}`);
    return {
      status: "failed",
      message: error.message,
    };
  }
}

export default function Lobby() {
  const { t } = useTranslation();
  const [isLang, setIsLang] = React.useState("en");
  const [gameList, setGameList] = React.useState([]);
  const [gameListStatus, setGameListStatus] = React.useState("");

  const [gameAction, setGameAction] = React.useState("start");
  const lottieRef = React.useRef();
  const [open, setOpen] = React.useState(false);

  const [innerWidth, setInnerWidth] = React.useState(window.innerWidth);
  let navigate = useNavigate();
  //let dispatch = useDispatch();
  const userId = sessionStorage.getItem("userId");

  let gameItems = [];
  let { lang } = useParams();

  React.useEffect(() => {
    async function fetchData() {
      await setIsLang(lang);
      const gameListData = await getGameList(userId);
      //console.log(gameListData);
      if (gameListData.status === "success") {
        setGameListStatus(gameListData.status);
        //setGameListStatus("error");
        const setpalay = gameListData.data.map(async (val, index) => {
          const play = await gameCalculatorPlayPerGame({
            game_id: val.id,
            profile_id: userId,
            play_per_game: "1",
          });
          val.play = play.status;
        });
        const dataPromise = await Promise.all(setpalay);
        setGameList(gameListData.data);
      }
    }
    fetchData();
  }, []);

  const handleChangeLang = (lang) => {
    window.location.href = `/${lang}/lobby`;
  };

  const handleMyReward = (e, lang) => {
    e.preventDefault();
    window.fbq("trackCustom", "my_reward_home");
    window.ttq.track("AddToWishlist");
    window.location.href = `/${lang}/my-reward`;
  };

  const handleClickStart = (e, game) => {
    e.preventDefault();
    window.fbq("trackCustom", "play_game");
    window.ttq.track("ClickButton");
    if (game.game_type === "BiggyDunkTank") {
      window.location.href = `/${isLang}/biggy-dunk-tank/${game.id}`;
    }
  };

  const handlePopup = (e) => {
    e.preventDefault();
    setOpen(true);
  };

  const handleClose = (e, reason) => {
    e.preventDefault();
    setOpen(false);
  };

  if (gameListStatus === "success" && gameList.length > 0) {
    gameItems = gameList.map((val, index) => {  
      return (
        <Grid item sm={12} xs={12} key={`game_` + index}>
          <Card sx={{ height: "100%", boxShadow: 0, borderRadius: 2 }}>
            <CardContent
              sx={{
                display: "flex",
                justifyContent: "center",
                width: "100%",
                padding: 0,
              }}
            >
              <Box className="lobby-box-game-list">
                <Box
                  className="lobby-img-game"
                  component="img"
                  src={lang === "cn" ? val.banner_cn : val.banner_en}
                  sx={{ width: "100%", height: "100%" }}
                />
                <Box className="lobby-button-game">
                  {val.play === "success" ? (
                    <Box className="lobby-btn-start-game">
                      <Button
                        id="btn-play-game"
                        sx={{ color: "#fff" }}
                        onClick={(e) => handleClickStart(e, val)}
                        endIcon={<PlayArrowIcon />}
                      >
                        {t("btn_Lobby_play")}
                      </Button>
                    </Box>
                  ) : (
                    <Box className="lobby-btn-start-game">
                      <Button
                        id="btn-play-game"
                        sx={{
                          color: "#fff",
                          background: "none",
                          backgroundColor: "#ccc",
                        }}
                        onClick={(e) => handlePopup(e, val)}
                        endIcon={<PlayArrowIcon />}
                      >
                        {t("btn_Lobby_play")}
                      </Button>
                    </Box>
                  )}
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Grid>
      );
    });

    gameItems = (
      <Grid container spacing={1}>
        {gameItems}
      </Grid>
    );
  } else {
    gameItems = (
      <Grid container spacing={1}>
        <Grid item sm={12} xs={12}>
          <Card sx={{ height: "100%", boxShadow: 0, borderRadius: 2 }}>
            <CardContent
              sx={{
                display: "flex",
                justifyContent: "center",
                width: "100%",
              }}
            >
              {/*<Box className="lobby-box-game-list">
                <Box
                  className="lobby-img-game"
                  component="img"
                  src="/game-img/coming-soon.jpg"
                  sx={{ width: "100%", height: "100%" }}
                />
            </Box>*/}
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    );
  }
  return (
    <Layout>
      <Box sx={{ minHeight: 800, width: "100%", boxShadow: "none" }}>
        <Box sx={{ m: 2 }}>
          <Grid container spacing={1}>
            <Grid item sm={12} xs={12}>
              <Box className="lobby-box-game">
                <Grid container spacing={1}>
                  <Grid item xs={6} sm={6}>
                    <Box className="lobby-box-reward">
                      <Box className="lobby-btn-reward">
                        <Button
                          id="btn-my-reward-game"
                          sx={{ color: "#fff" }}
                          onClick={(e) => handleMyReward(e, isLang)}
                          startIcon={<EmojiEventsIcon />}
                        >
                          {t("btn_Reward")}
                        </Button>
                      </Box>
                    </Box>
                  </Grid>
                  <Grid item xs={6} sm={6}>
                    <Box className="main-box-len">
                      <Box className="box-btn-len">
                        <Button
                          className={
                            isLang === "en" ? "active radiusLeft" : "radiusLeft"
                          }
                          sx={{ color: "#fff", float: "left" }}
                          onClick={(e) => handleChangeLang("en")}
                        >
                          EN
                        </Button>
                        <Button
                          className={
                            isLang === "cn"
                              ? "active radiusRight"
                              : "radiusRight"
                          }
                          sx={{ color: "#fff" }}
                          onClick={(e) => handleChangeLang("cn")}
                        >
                          中文
                        </Button>
                      </Box>
                    </Box>
                  </Grid>
                  <Grid item sm={12} xs={12}>
                    <Box
                      className="render-paper-box"
                      sx={{ pt: 2, pl: 1, pr: 1, pb: 10 }}
                    >
                      {gameItems}
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Box>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        scroll="body"
      >
        <DialogContent className="box-award-dialog">
          <Grid container spacing={1}>
            <Grid item sm={12} xs={12}>
              <CardMedia
                className="box-award-img"
                component="img"
                image="/img/biggy.png"
                alt="biggy"
              />
            </Grid>
            <Grid item sm={12} xs={12}>
              <Box className="box-award-detail">
                <Typography variant="h6" component="div">
                  {t("alert_limit_play")}
                </Typography>
                <Typography variant="body" component="div">
                  {t("thank_for_play")}
                </Typography>
                <Typography variant="body" component="div">
                  {t("can_use_coupon")}
                </Typography>
                <Typography variant="body" component="div">
                  {t("to_reward")}
                </Typography>
                <Box className="btn-award">
                  <Button
                    id="btn-result-game-failed"
                    sx={{ color: "#fff" }}
                    onClick={(e) => handleMyReward(e, lang)}
                  >
                    {t("btn_Reward")}
                  </Button>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
    </Layout>
  );
}
